import { render, staticRenderFns } from "./OrderTypesChart.vue?vue&type=template&id=dc37fd58&lang=pug"
import script from "./OrderTypesChart.vue?vue&type=script&lang=js"
export * from "./OrderTypesChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports